export default "__VITE_ASSET__m4f$8m76__"